<span>{{getDisplayText()}}</span>